<div id="quickplay">
    <div class="buttons">
        <button id="btn-10x10">
            <span class="play">Play</span>
            <span class="size">10x10</span>
        </button>
        <button id="btn-15x15">
            <span class="play">Play</span>
            <span class="size">15x15</span>
        </button>
        <button id="btn-20x20">
            <span class="play">Play</span>
            <span class="size">20x20</span>
        </button>
        <button id="btn-30x30">
            <span class="play">Play</span>
            <span class="size">30x30</span>
        </button>
        <button id="btn-40x40">
            <span class="play">Play</span>
            <span class="size">40x40</span>
        </button>
        <button id="btn-large">
            <span class="play">Play</span>
            <span class="size">&gt;40x40</span>
        </button>
    </div>
</div>